<template>
  <div class="dangling">
    <div class="side-share">
      <div class="common-share img1" @click="handleTarget('hot')">
        <img src="@/assets/img/hotline.png" alt="" />
        <span>客服热线</span>
      </div>
      <div class="common-share img2" @click="handleTarget('ewm')">
        <img src="@/assets/img/erweima.png" alt="" />
        <span>公众号</span>
      </div>
      <div class="common-share img3" @click="handleTarget('applet')">
        <img src="@/assets/img/applet.png" alt="" />
        <span>小程序</span>
      </div>
      <div class="common-share img4">
        <el-backtop>
          <img src="@/assets/img/goTop.png" alt="" />
          <span>返回顶部</span>
        </el-backtop>
      </div>
    </div>
    <div class="side-hotline" v-if="showHotline">
      <img src="@/assets/img/hotline-number.png" alt="" />
    </div>
    <div class="side-ewm1" v-if="showEwm">
      <img src="@/assets/img/side-ewm1.png" alt="" />
    </div>
    <div class="side-ewm2" v-if="showApplet">
      <img src="@/assets/img/side-ewm2.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      showHotline: false,
      showEwm: false,
      showApplet: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleTarget(val) {
      if (val == "hot") {
        this.showHotline = !this.showHotline;
        this.showEwm = false;
        this.showApplet = false;
      } else if (val == "ewm") {
        this.showEwm = !this.showEwm;
        this.showHotline = false;
        this.showApplet = false;
      } else {
        this.showApplet = !this.showApplet;
        this.showEwm = false;
        this.showHotline = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dangling {
  .side-share {
    width: 80px;
    height: 350px;
    position: fixed;
    top: 340px;
    right: 0;
    transition: all 0.4s;
    background: #f6f7f9;
    cursor: pointer;
    user-select: none;
    z-index: 999;
    .common-share {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
      img {
        width: 24px;
        height: 24px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        margin-top: 10px;
      }
    }
    .img1:hover img {
      content: url("~@/assets/img/hotline-red.png");
    }
    .img2:hover img {
      content: url("~@/assets/img/erweima-red.png");
    }
    .img3:hover img {
      content: url("~@/assets/img/applet-red.png");
    }
    .img4:hover img {
      content: url("~@/assets/img/goTop-red.png");
    }
    .common-share:hover span {
      color: #fb463f;
    }
  }
  .side-hotline {
    position: fixed;
    right: 80px;
    top: 340px;
    img {
      width: 280px;
      height: 102px;
    }
  }
  .side-ewm1 {
    position: fixed;
    right: 80px;
    top: 340px;
    img {
      width: 280px;
      height: 270px;
    }
  }
  .side-ewm2 {
    position: fixed;
    right: 80px;
    top: 420px;
    img {
      width: 280px;
      height: 270px;
    }
  }
}
/deep/ .el-backtop {
  width: 100%;
  height: 100%;
  position: static;
  background-color: transparent;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
